import { requestAction } from "../actionlog/actionLogActions"
import PriceList from "./PriceList"
import { SET_PRICE_LIST } from "./priceListActionTypes"
import PriceListService from "./PriceListService"


export function updatePriceListAction(priceList?: PriceList) {
    return {
        type: SET_PRICE_LIST,
        payload: {
            priceListId: priceList?.getId(),
            priceList: priceList,
        }
    }
}
export function updatePriceList(priceList?: PriceList) {
    return async (dispatch) => {
        dispatch(updatePriceListAction(priceList))
    }
}

export function patchPriceList(id: string, payload: object, actionId: string) {
    return async (dispatch) => {
        dispatch(
            requestAction<PriceList>(
                () => PriceListService.update(id, payload),
                updatePriceListAction,
                actionId,
            )
        )
    }
}

export function fetchPriceList(id: string) {
    return async (dispatch) => {
        const priceList = await PriceListService.get(id)
        if (priceList instanceof PriceList) {
            dispatch(updatePriceListAction(priceList))
        }
    }
}



// WEBPACK FOOTER //
// ./src/state/price-list/priceListActions.ts